import { axios } from '@/utils/request'

const api = {

  logisticsLogPage: '/logisticsLog/page',
  logisticsLogDelete: '/logisticsLog/delete',

  doorPage: '/door/page',
  doorDelete: '/door/delete',

  grantCardPage: '/grantCard/page',
  grantCardDelete: '/grantCard/delete',
  grantCard: '/grantCard/grantCard',
  grantCardCancellation: '/grantCard/cancellation',
  grantCardRecoveryCard: '/grantCard/recoveryCard',
  grantCardGetBasicForYTSOFT: '/grantCard/getBasicForYTSOFT',
  grantCardGetBasicAll: '/grantCard/getBasicAll',
  grantCardValidate: '/grantCard/grantCardValidate',
  grantCardAction: '/grantCard/grantCardAction',
  recoveryCardCanQuery: '/grantCard/canRecoveryCardQuery',
  grantCardCanQuery: '/grantCard/canGrantCardQuery',

  loadVehiclePage: '/loadVehicle/page',
  loadVehicleDelete: '/loadVehicle/delete',


  // 预约相关接口
  deleteReservation: '/reservation/deleteReservation',
  reservationPage: '/reservation/page',
  reservationAudit: '/reservation/audit',
  reservationInvalid: '/reservation/invalid',
  reservationAdd: '/reservation/add',
  reservationExport: '/reservation/createReservationExcel',
  baseInfoList: '/reservation/baseInfoList',
  reservationAddMulti: '/reservation/addMulti',
  queryOrder: '/reservation/queryOrder',
  resetErrorCount: '/reservation/resetErrorCount',
  batchApprove: '/reservation/batchApprove',

  // 物流相关接口
  logisticsPage: '/logistics/page',
  yyedit: '/logistics/yyedit',

  logisticsFindLogisticsByReservationNo: '/logistics/findLogisticsByReservationNo',
  logisticsFindByVerificationCode: '/logistics/findByVerificationCode',
  logisticsFindLogisticsInfoData: '/logistics/findLogisticsInfoData',
  logisticsBackStep: '/logistics/logisticsBackStep',
  logisticsCorrectRecord: '/logistics/correctRecord',
  logisticsSetDeleted: '/logistics/setDeleted',
  //换客户
  setCustomerChange: '/logistics/setCustomerChange',
  xsdetils: '/logistics/xsfydetils',


  getSellData: '/statistics/getSellData',
  getPurchaseData: '/statistics/getPurchaseData',
  getSellBar: '/statistics/getSellBar',
  getPortSellBar: '/statistics/getPortSellBar',
  getVehicleNumBar: '/statistics/getVehicleNumBar',
  getTodayPurchaseBar: '/statistics/getTodayPurchaseBar',
  roleLimit: '/statistics/roleLimit',

  // 称重相关接口
  weighingPage: '/weighing/page',
  reportPage: '/weighing/reportPage',
  reportWeightPage: '/weighing/reportWeightPage',
  reportDayPage: '/weighing/reportDayPage',
  weighingStatistics: '/weighing/weighingStatistics',
  weighingUploadInfo: '/weighing/getUploadInfo',
  weighingDelete: '/weighing/delete',
  weighingDetails: '/weighing/details',
  weighingUpdate: '/weighing/update',
  weighingUpdateWeighingInfo: '/weighing/updateWeighingInfo',
  weighingExport: '/weighing/createWeighingExcel',
  weighingOrder: '/weighing/getWeighingOrder',
  standDetailExport: '/weighing/createStandDetailExcel',
  standStatisticVoExport: '/weighing/createStandStatisticVoExcel',
  reportVoExport: '/weighing/createReportVoExcel',
  dayinbangdan: 'http://127.0.0.1:5050',
  //新称重磅单打印

  // 地磅日志
  weighingLogPage: '/weighingLog/page',
  weighingLogDelete: '/weighingLog/delete',
  weighingLogsave: '/weighingLog/save',
  weighingLogUpdate: '/weighingLog/update',

  // 化验结果相关接口
  assayPage: '/assay/page',


  // 物流上传相关接口
  uploadPage: '/upload/page',
  uploadUpload: '/upload/upload',

  // QRCodeGrantCard: '/QRCodeGrantCard/grantCardByVerificationCode'
  QRCodeGrantCard: '/QRCodeGrantCard/findAttachementId'
}

export default api

export function logisticsLogPage(parameter) {
  return axios({
    url: api.logisticsLogPage,
    method: 'post',
    data: parameter
  })
}
export function logisticsLogDelete(parameter) {
  return axios({
    url: api.logisticsLogDelete,
    method: 'get',
    params: parameter
  })
}

export function doorPage(parameter) {
  return axios({
    url: api.doorPage,
    method: 'post',
    data: parameter
  })
}
export function doorDelete(parameter) {
  return axios({
    url: api.doorDelete,
    method: 'get',
    params: parameter
  })
}

export function grantCardPage(parameter) {
  return axios({
    url: api.grantCardPage,
    method: 'post',
    data: parameter
  })
}

export function grantCardDelete(parameter) {
  return axios({
    url: api.grantCardDelete,
    method: 'get',
    params: parameter
  })
}
export function grantCard(parameter) {
  return axios({
    url: api.grantCard,
    method: 'get',
    params: parameter
  })
}
export function grantCardCancellation(parameter) {
  return axios({
    url: api.grantCardCancellation,
    method: 'get',
    params: parameter
  })
}
export function grantCardRecoveryCard(parameter) {
  return axios({
    url: api.grantCardRecoveryCard,
    method: 'get',
    params: parameter
  })
}
export function grantCardGetBasicForYTSOFT(parameter) {
  return axios({
    url: api.grantCardGetBasicForYTSOFT,
    method: 'get',
    params: parameter
  })
}
export function grantCardGetBasicAll(parameter) {
  return axios({
    url: api.grantCardGetBasicAll,
    method: 'get',
    params: parameter
  })
}
export function grantCardValidate(parameter) {
  return axios({
    url: api.grantCardValidate,
    method: 'get',
    params: parameter
  })
}
export function grantCardAction(parameter) {
  return axios({
    url: api.grantCardAction,
    method: 'get',
    params: parameter
  })
}
export function grantCardCanQuery(parameter) {
  return axios({
    url: api.grantCardCanQuery,
    method: 'get',
    params: parameter
  })
}

export function recoveryCardCanQuery(parameter) {
  return axios({
    url: api.recoveryCardCanQuery,
    method: 'get',
    params: parameter
  })
}

export function loadVehiclePage(parameter) {
  return axios({
    url: api.loadVehiclePage,
    method: 'post',
    data: parameter
  })
}
export function loadVehicleDelete(parameter) {
  return axios({
    url: api.loadVehicleDelete,
    method: 'get',
    params: parameter
  })
}

/**
 * 预约记录查询
 * @param parameter
 * @returns {*}
 */
export function reservationPage(parameter) {
  return axios({
    url: api.reservationPage,
    method: 'post',
    data: parameter
  })
}

/**
 * 预约记录审核或拒绝
 * @param parameter
 * @returns {*}
 */
export function reservationAudit(parameter) {
  return axios({
    url: api.reservationAudit,
    method: 'post',
    data: parameter
  })
}

/**
 * 预约记录作废
 * @param parameter
 * @returns {*}
 */
export function reservationInvalid(parameter) {
  return axios({
    url: api.reservationInvalid,
    method: 'post',
    data: parameter
  })
}

/**
 * 预约记录添加
 * @param parameter
 * @returns {*}
 */
export function reservationAdd(parameter) {
  return axios({
    url: api.reservationAdd,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function reservationAddMulti(parameter) {
  return axios({
    url: api.reservationAddMulti,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function resetErrorCount(parameter) {
  return axios({
    url: api.resetErrorCount,
    method: 'post',
    data: parameter
  })
}

export function reservationExport(parameter) {
  return axios({
    url: api.reservationExport,
    method: 'post',
    data: parameter
  })
}

export function queryOrder(parameter) {
  return axios({
    url: api.queryOrder,
    method: 'post',
    data: parameter
  })
}

export function baseInfoList(parameter) {
  return axios({
    url: api.baseInfoList,
    method: 'get',
    params: parameter
  })
}

export function deleteReservation(parameter) {
  return axios({
    url: api.deleteReservation,
    method: 'get',
    params: parameter
  })
}



export function batchApprove(parameter) {
  return axios({
    url: api.batchApprove,
    method: 'get',
    params: parameter
  })
}



/**
 * 物流记录查询
 * @param parameter
 * @returns {*}
 */
export function logisticsPage(parameter) {
  return axios({
    url: api.logisticsPage,
    method: 'post',
    data: parameter
  })
}


export function logisticsFindLogisticsByReservationNo(parameter) {
  return axios({
    url: api.logisticsFindLogisticsByReservationNo,
    method: 'get',
    params: parameter
  })
}





export function yyedit(parameter) {
  return axios({
    url: api.yyedit,
    method: 'post',
    data: parameter
  })
}


export function logisticsFindByVerificationCode(parameter) {
  return axios({
    url: api.logisticsFindByVerificationCode,
    method: 'get',
    params: parameter
  })
}
export function logisticsFindLogisticsInfoData(parameter) {
  return axios({
    url: api.logisticsFindLogisticsInfoData,
    method: 'get',
    params: parameter
  })
}
export function logisticsBackStep(parameter) {
  return axios({
    url: api.logisticsBackStep,
    method: 'get',
    params: parameter
  })
}

export function logisticsCorrectRecord(parameter) {
  return axios({
    url: api.logisticsCorrectRecord,
    method: 'post',
    data: parameter
  })
}

export function logisticsSetDeleted(parameter) {
  return axios({
    url: api.logisticsSetDeleted,
    method: 'get',
    params: parameter
  })
}

export function setCustomerChange(parameter) {
  return axios({
    url: api.setCustomerChange,
    method: 'get',
    params: parameter
  })
}


export function xsdetils(parameter) {
  return axios({
    url: api.xsdetils,
    method: 'post',
    data: parameter
  })
}


/**
 * 称重记录查询
 * @param parameter
 * @returns {*}
 */
export function weighingPage(parameter) {
  return axios({
    url: api.weighingPage,
    method: 'post',
    data: parameter
  })
}

export function reportPage(parameter) {
  return axios({
    url: api.reportPage,
    method: 'post',
    data: parameter
  })
}

export function reportWeightPage(parameter) {
  return axios({
    url: api.reportWeightPage,
    method: 'post',
    data: parameter
  })
}

export function reportDayPage(parameter) {
  return axios({
    url: api.reportDayPage,
    method: 'post',
    data: parameter
  })
}

export function standDetailExport(parameter) {
  return axios({
    url: api.standDetailExport,
    method: 'post',
    data: parameter
  })
}

export function standStatisticVoExport(parameter) {
  return axios({
    url: api.standStatisticVoExport,
    method: 'post',
    data: parameter
  })
}

export function reportVoExport(parameter) {
  return axios({
    url: api.reportVoExport,
    method: 'post',
    data: parameter
  })
}

export function dayinbangdan(parameter) {
  return axios({
    url: "http://127.0.0.1:5050",
    method: 'post',
    data: parameter
  })
}


export function weighingStatistics(parameter) {
  return axios({
    url: api.weighingStatistics,
    method: 'post',
    data: parameter
  })
}
/**
 * 获取称重上传信息
 * @param {*} parameter
 */
export function weighingUploadInfo(parameter) {
  return axios({
    url: api.weighingUploadInfo,
    method: 'get',
    params: parameter
  })
}

export function weighingDelete(parameter) {
  return axios({
    url: api.weighingDelete,
    method: 'get',
    params: parameter
  })
}

export function weighingDetails(parameter) {
  return axios({
    url: api.weighingDetails,
    method: 'get',
    params: parameter
  })
}

export function weighingUpdate(parameter) {
  return axios({
    url: api.weighingUpdate,
    method: 'post',
    data: parameter
  })
}

export function weighingUpdateWeighingInfo(parameter) {
  return axios({
    url: api.weighingUpdateWeighingInfo,
    method: 'post',
    data: parameter
  })
}

export function weighingExport(parameter) {
  return axios({
    url: api.weighingExport,
    method: 'post',
    data: parameter
  })
}

export function weighingOrder(parameter) {
  return axios({
    url: api.weighingOrder,
    method: 'get',
    params: parameter
  })
}

// 地磅日志
export function weighingLogPage(parameter) {
  return axios({
    url: api.weighingLogPage,
    method: 'get',
    params: parameter
  })
}
export function weighingLogDelete(parameter) {
  return axios({
    url: api.weighingLogDelete,
    method: 'get',
    params: parameter
  })
}
export function weighingLogsave(parameter) {
  return axios({
    url: api.weighingLogsave,
    method: 'post',
    data: parameter
  })
}
export function weighingLogUpdate(parameter) {
  return axios({
    url: api.weighingLogUpdate,
    method: 'post',
    data: parameter
  })
}

/**
 * 化验记录查询
 * @param parameter
 * @returns {*}
 */
export function assayPage(parameter) {
  return axios({
    url: api.assayPage,
    method: 'get',
    params: parameter
  })
}


/**
 * 物流上传分页查询
 */
export function uploadPage(parameter) {
  return axios({
    url: api.uploadPage,
    method: 'get',
    params: parameter
  })
}
/**
 * 物流手动上传
 */
export function uploadUpload(parameter) {
  return axios({
    url: api.uploadUpload,
    method: 'post',
    data: parameter
  })
}


export function getSellData(parameter) {
  return axios({
    url: api.getSellData,
    method: 'get',
    params: parameter
  })
}


export function roleLimit(parameter) {
  return axios({
    url: api.roleLimit,
    method: 'get',
    params: parameter
  })
}


export function getSellBar(parameter) {
  return axios({
    url: api.getSellBar,
    method: 'get',
    params: parameter
  })
}
export function getPurchaseData(parameter) {
  return axios({
    url: api.getPurchaseData,
    method: 'get',
    params: parameter
  })
}
export function getPortSellBar(parameter) {
  return axios({
    url: api.getPortSellBar,
    method: 'get',
    params: parameter
  })
}
export function getVehicleNumBar(parameter) {
  return axios({
    url: api.getVehicleNumBar,
    method: 'get',
    params: parameter
  })
}
export function getTodayPurchaseBar(parameter) {
  return axios({
    url: api.getTodayPurchaseBar,
    method: 'get',
    params: parameter
  })
}

export function QRCodeGrantCard(parameter) {
  return axios({
    url: api.QRCodeGrantCard,
    method: 'get',
    params: parameter
  })
}
